<!--
 * @Author: guoyu
 * @Date: 2020-05-08 16:27:08
 * @LastEditors: your name
 * @LastEditTime: 2020-05-18 19:10:38
 * @Description: 计数器
 -->
<template>
  <div class="input-number-wrap" :class="{ 'all-disabled': disabled }">
    <div
      :class="['minus', (!value || value <= min) ? 'disabled' : '']"
      @click="changeVal(-1)"
    ></div>
    <input
      class="input-num"
      type="number"
      v-model.number="val"
      pattern="[0-9]*"
      @input="inputValue"
      @change="numberChange"
    />
    <div
      :class="['plus', value >= max ? 'disabled' : '']"
      @click="changeVal(1)"
    >
      <div class="vertical"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputNumber',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Number,
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: 0,
      isDefault: true, // 是否為初始化默認值
    }
  },
  watch: {
    value(value) {
      if (value > this.max) {
        this.$emit('change', this.max);
      }
      // if (
      //   (Object.prototype.toString.call(value) !== '[object Number]' ||
      //   value < this.min) && this.isDefault
      // ) {
      //   this.$emit('change', this.min);
      // }
      if (typeof value === 'number' && value) {
        this.val = value
      }
    },
  },
  created() {
    this.defaultData()
  },
  methods: {
    numberChange() {
      if (!this.val || this.val < this.min) {
        if (this.value === this.min) {
          this.val = this.min
        } else {
          this.$emit('change', this.min)
        }
      }
    },
    defaultData() {
      const { value } = this
      if (value > this.max) {
        this.$emit('change', this.max);
      } else if (
        (Object.prototype.toString.call(value) !== '[object Number]' ||
        value < this.min) && this.isDefault
      ) {
        this.$emit('change', this.min);
      }
      this.isDefault = false
      this.val = value
    },
    inputValue(event) {
      if (this.disabled) return;
      let value = event.target.value;
      if (value >= this.max) value = this.max;
      // if (value <= this.min) value = this.min;
      if (this.value === +(value)) {
        this.val = value
      } else {
        this.$emit('change', value ? parseInt(value) : 0);
      }
    },
    changeVal(step) {
      if (this.disabled) return;
      let val = (this.value || this.min) + step;
      if (val >= this.max) val = this.max;
      if (val <= this.min) val = this.min;
      this.$emit('change', val);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-number-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}
.minus,
.plus {
  position: relative;
  width: 36px;
  height: 36px;
  cursor: pointer;
  font-size: 0;
  &::before,
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &::after {
    width: 10px;
    height: 1px;
    background: #666666;
  }
  &::before {
    height: 24px;
    width: 24px;
    border: solid 1px #666666;
    border-radius: 50%;
  }
  &.disabled {
    opacity: 0.5;
  }
}
.vertical {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1px;
  height: 10px;
  background: #666666;
}
.all-disabled {
  opacity: 0.3;
}
.input-num {
  width: 36px;
  height: 30px;
  font-size: 18px;
  line-height: 20px;
  font-weight: 600;
  color: #333;
  text-align: center;
  user-select: auto !important;
  -webkit-user-select: auto !important;
  background: $color-light;
  border-radius: 2px;
}
@media screen and (min-width: 600px) {
  .input-number-wrap {
    height: 42px;
    border: solid 1px #ececec;
    border-radius: 6px;
  }
  .minus,
  .plus {
    width: 48px;
    height: 40px;
    background: #f6f6f6;
    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &::after {
      width: 10px;
      height: 2px;
      border-radius: 1px;
      background: $color-yellow;
    }
    &::before {
      display: none;
    }
  }
  .minus {
    border-right: 1px solid #ececec;
  }
  .plus {
    border-left: 1px solid #ececec;
  }
  .vertical {
    width: 2px;
    border-radius: 1px;
    background: $color-yellow;
  }
  .disabled {
    &::after {
      background: #dddddd;
    }
    .vertical {
      background: #dddddd;
    }
  }
  .input-num {
    width: 48px;
    background: none;
  }
}
</style>
